/*
 * /reset/{token}: "Redefinir senha" com a cara das páginas de entrar (logo,
 * cartão, título, campos com rótulo flutuante), no lugar da página solta do
 * core. O servidor (src/Auth/ResetPasswordContent) valida o token como o
 * core e entrega o token e os erros da última tentativa; o formulário posta
 * no POST /reset do core (SavePasswordController), que troca a senha, entra
 * e volta para a página inicial — ou, num erro, volta para cá com os erros.
 */
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import { t } from '../../utils/settings';
import { authLogo, backToLogin, enterAuthRoute, leaveAuthRoute } from './AuthPage';
export default class ResetPasswordPage extends Page {
  bodyClass = 'Canela--authPage';
  loading = false;
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(t('auth.reset_heading'));
    app.setTitleCount(0);
  }
  payload() {
    const data = app.data.canelaReset;

    // Só vale o token da própria URL (o payload é o do primeiro carregamento).
    return data && data.token === m.route.param('token') ? data : null;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    enterAuthRoute();
  }
  onremove(vnode) {
    super.onremove(vnode);
    leaveAuthRoute();
  }
  view() {
    const data = this.payload();
    return m("div", {
      className: "CanelaAuthPage CanelaAuthPage--reset CanelaAuthPage--layout-card"
    }, m("div", {
      className: "CanelaAuthPage-inner"
    }, authLogo(), m("div", {
      className: "Modal modal-dialog CanelaAuthForm CanelaResetForm"
    }, m("div", {
      className: "Modal-content"
    }, data ? this.form(data) : this.unavailable())), backToLogin()));
  }
  form(data) {
    return m("form", {
      method: "POST",
      action: `${app.forum.attribute('baseUrl')}/reset`,
      onsubmit: () => this.loading = true
    }, m("div", {
      className: "Modal-header"
    }, m("h3", {
      className: "App-titleControl App-titleControl--text"
    }, t('auth.reset_heading'))), data.errors.length ? m("div", {
      className: "Modal-alert"
    }, m("div", {
      className: "Alert Alert--error",
      role: "alert"
    }, m("span", {
      className: "Alert-body"
    }, data.errors.map(error => m("p", null, error))))) : null, m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form Form--centered"
    }, m("input", {
      type: "hidden",
      name: "csrfToken",
      value: app.session.csrfToken
    }), m("input", {
      type: "hidden",
      name: "passwordToken",
      value: data.token
    }), m("p", {
      className: "helpText"
    }, t('auth.reset_help')), this.field('password', t('auth.reset_new_password'), true), this.field('password_confirmation', t('auth.reset_confirm_password'), false), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, t('auth.reset_submit'))))));
  }
  field(name, label, focus) {
    return m("div", {
      className: "Form-group CanelaFloat"
    }, m("input", {
      className: "FormControl",
      type: "password",
      name: name,
      autocomplete: "new-password",
      placeholder: " ",
      "aria-label": label,
      required: true,
      minlength: 8,
      oncreate: focus ? vnode => vnode.dom.focus() : undefined
    }), m("label", {
      className: "CanelaFloat-label",
      "aria-hidden": "true"
    }, label));
  }

  /** Chegou aqui navegando dentro do fórum (sem o payload do servidor): recarrega a página. */
  unavailable() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "helpText"
    }, m("a", {
      href: window.location.href,
      onclick: () => window.location.reload()
    }, t('auth.reset_heading'))));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/auth/ResetPasswordPage', ResetPasswordPage);